import { render } from "./PaymentRegister.vue?vue&type=template&id=4403f5db&scoped=true&ts=true"
import script from "./PaymentRegister.vue?vue&type=script&lang=ts"
export * from "./PaymentRegister.vue?vue&type=script&lang=ts"

import "./PaymentRegister.vue?vue&type=style&index=0&id=4403f5db&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4403f5db"]])

export default __exports__